import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _UserGetter = Getter.of();
export const _UserResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _UserResponse2User = _Response2ResponseData();
export const _UserResponse2Meta = Fold.compose(_UserResponseGetter, Res._Response(), Lens.prop("meta"));
export const _User2Data = Fold.compose(_UserGetter, Res._Response());
export const _User2Attributes = Fold.compose(_User2Data, Lens.prop("attributes"));
export const _UserAttributes2Anonymous = Fold.compose(_User2Attributes, Lens.prop("anonymous"));
export const _UserAttributes2Bucket = Fold.compose(_User2Attributes, Lens.prop("bucket"));
export const _UserAttributes2EmailValidationStatus = Fold.compose(_User2Attributes, Lens.prop("emailValidationStatus"));
export const _UserAttributes2Realm = Fold.compose(_User2Attributes, Lens.prop("realm"));
export const _UserAttributes2NewsletterPreference = Fold.compose(_User2Attributes, Lens.prop("newsletterPreference"));
export const _UserAttributes2Packages = Fold.compose(_User2Attributes, Lens.prop("packages"));
export const _UserAttributes2Products = Fold.compose(_User2Attributes, Lens.prop("products"));
export const _UserAttributes2Features = Fold.compose(_User2Attributes, Lens.prop("features"));
export const _UserAttributes2SelectedProfileId = Fold.compose(_User2Attributes, Lens.prop("selectedProfileId"));
export const _UserAttributes2FirstName = Fold.compose(_User2Attributes, Lens.prop("firstName"));
export const _UserAttributes2LastName = Fold.compose(_User2Attributes, Lens.prop("lastName"));
export const _UserAttributes2Username = Fold.compose(_User2Attributes, Lens.prop("username"));
export const _UserAttributes2Region = Fold.compose(_User2Attributes, Lens.prop("region"));
export const _UserAttributes2Roles = Fold.compose(_User2Attributes, Lens.prop("roles"));
export const _UserAttributes2ToolboxIDP = Fold.compose(_User2Attributes, Lens.prop("toolboxIDP"));
export const _UserAttributes2SelectedAuthProvider = Fold.compose(_User2Attributes, Lens.prop("selectedAuthProvider"));
export const _UserAttributes2AuthProviders = Fold.compose(_User2Attributes, Lens.prop("authProviders"));
export const _UserAttributes2Deleted = Fold.compose(_User2Attributes, Lens.prop("deleted"));
export const _UserAttributes2LastLoginTime = Fold.compose(_User2Attributes, Lens.prop("lastLoginTime"));
export const _UserAttributes2CurrentLocationTerritory = Fold.compose(_User2Attributes, Lens.prop("currentLocationTerritory"));
export const _UserAttributes2CurrentLocationSovereignTerritory = Fold.compose(_User2Attributes, Lens.prop("currentLocationSovereignTerritory"));
export const _UserAttributes2CurrentlyLocatedInEU = Fold.compose(_User2Attributes, Lens.prop("currentlyLocatedInEU"));
export const _UserAttributes2VerifiedHomeTerritory = Fold.compose(_User2Attributes, Lens.prop("verifiedHomeTerritory"));
export const _UserAttributes2DerivedLanguageTags = Fold.compose(_User2Attributes, Lens.prop("derivedLanguageTags"));
export const _UserAttributes2ClientTranslationLanguageTags = Fold.compose(_User2Attributes, Lens.prop("clientTranslationLanguageTags"));
export const _UserAttributes2ValidatedPhoneNumber = Fold.compose(_User2Attributes, Lens.prop("validatedPhoneNumber"));

